













































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import EventBus from '../../services/eventbus.service';
import FilterBar from '@/components/FilterBar.vue';
import {
  Getter,
  Mutation,
  Action,
} from 'vuex-class';
import { DataTable as DataTableModel } from '@/types';

@Component({
  components: {
    FilterBar,
  },
})

export default class TableWidget extends Vue {
  @Prop({default: {}}) private data!: any;
  @Prop() private container: any;
  private visibleHeaders: any[] = [];
  private totals: any[] = [];
  private tableData: any[] = [];
  private rowClicked: boolean = false;
  private defaultsApplied: boolean = false;
  private launched: boolean = false;
  private dataTableHeight: number = 0;
  private dataTable: DataTableModel = {
    activeFilterOptions: {},
    activePage: 1,
    entity: 'device',
    perPageValue: 100,
    orderOptions: {},
  };

  @Getter private widgetFilters!: string[];
  @Getter private activeOrganisation: any;
  @Action private changeProjectAsync: any;
  @Action private changeOrganisationAsync: any;
  @Mutation private addWidgetFilters: any;

  @Watch('container')
  private onContainerResize() {
    if (this.container) {
      this.dataTableHeight = (this.container.$el as HTMLElement).offsetHeight - 64;
    }
  }

  private mounted() {
    this.initFilters();
    EventBus.$on('defaultColsSet', this.applyDefaults);
    EventBus.$on('toggleCols', this.applyColumnChanges);
    EventBus.$on('clearFilter', this.clearFilters);
    this.getTotals();
  }

  private beforeDestroy() {
    EventBus.$off('defaultColsSet', this.applyDefaults);
    EventBus.$off('toggleCols', this.applyColumnChanges);
    EventBus.$off('clearFilter', this.clearFilters);
  }

  private getRowClass(item: any) {
    const rowClass: string = 'dashboard-table-font';
    return rowClass;
  }

  private getStatusColor(value: string) {
    switch (value) {
      case 'deviceFaultCount': return 'bg-red';
      case 'deviceActiveCount': return 'bg-green-700';
      default: return 'primary';
    }
  }

  private initFilters() {
    Vue.set(this, 'tableData', this.data.payload.values);
    let filters = this.widgetFilters;
    filters = filters.filter((f: string) => f !== null);
    if (filters && filters.length) {
      const rowExists = this.tableData.some((row: any) => filters.includes(row.projectName));
      const rows = this.tableData.filter((row: any) => filters.find((filter: string) => {
        return row.projectName === filter;
      }));
      Vue.set(this, 'tableData', rows);
      if (!rowExists) {
        EventBus.$emit('filterByProject', null);
        return;
      }
      rows.map((row: any) => EventBus.$emit('filterByProject', row.projectName));
    }
  }
  private filterBy(projectName: string) {
    EventBus.$emit('filterByProject', projectName);

    this.rowClicked = true;
    this.addWidgetFilters(projectName);
    this.tableData = this.tableData.filter((currRow: any) => {
      return currRow.projectName === projectName;
    });


    this.getTotals();
  }

  private clearFilters() {
    this.tableData = [...this.data.payload.values];
    this.rowClicked = false;

    this.getTotals();
  }

  private getInitials(name: string) {
    if (name) {

      const parts = name.split(' ');
      let initials = '';
      // tslint:disable-next-line
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== '') {
          initials += parts[i][0];
        }
      }
      return initials;
    }
  }

  private getColor(name: string) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      // tslint:disable-next-line:no-bitwise
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      // tslint:disable-next-line:no-bitwise
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }

  private truncateText(text: string, maxLength: number) {
    if (!text) {
      return null;
    }
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  }

  private getTotals() {
    const sums: any = {};
    for (const row of this.tableData) {
      for (const key in row) {
        if (row.hasOwnProperty(key)) {
          if (typeof row[key] === 'number') {
            if (typeof sums[key] !== 'number') {
              sums[key] = 0;
            }
            sums[key] += row[key];
          } else {
            sums[key] = '';
          }
        }
      }
    }
    Vue.set(this, 'totals', sums);
  }

  private sumFields(row: any, key: string) {
    if (typeof row[key] === 'number') {
      return this.data.payload.values.reduce((a: any, b: any) => a + (b[key] || 0), 0);
    }
  }

  private applyDefaults() {
    if (this.data.payload && !this.defaultsApplied) {
      for (const header of this.data.payload.headers) {
        if (this.data.enabledFields.includes(header.value)) {
          this.visibleHeaders.push(header);
        }
      }
      this.defaultsApplied = true;
    }
  }

  private applyColumnChanges(col: any, toggled: string[], source: string, title: string, id: string) {
    if (source === 'table' && title === this.data.title) {
      const compared = this.data.payload.headers.filter((val: any) => toggled.includes(val.value));
      Vue.set(this, 'visibleHeaders', compared);

      if (id === this.data.id) {
        const headers = this.visibleHeaders.map((h: any) => h.value);
        this.data.enabledFields = headers;
      }
    }
  }

  private async goToDevicesWithFilter(organisationId: string, projectId: number, statusId: number) { // TODO: Take this up a level to avoid repetition
    if (!this.launched) {
      if (this.activeOrganisation === organisationId) {
        await this.changeProjectAsync({projectId, forceRender: false});
      } else {
        /* eslint-disable object-literal-shorthand */
        // eslint-disable-line object-literal-shorthand
        await this.changeOrganisationAsync({
          orgId: organisationId,
          forceRender: false,
        });
        await this.changeProjectAsync({projectId, forceRender: false});
      }

      const key = statusId.toString();
      const filters: any = {};
      filters.statuses = {};
      filters.statuses[key] = true;

      this.launched = true;
      this.$router.push({name: 'devices', params: { organisationId: organisationId.toString(), filters: JSON.stringify(filters) }});
    }
  }

}
